import { PublicClientApplication } from '@azure/msal-browser'
import config from './config'

export default new PublicClientApplication({
  auth: {
    clientId: config.clientId,
    authority: config.authority,
    // Follows whatever origin the app is served from, so the same build works
    // locally and in every deployed environment. Each origin must be registered
    // as a redirect URI in the Azure AD app registration.
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
})
